module.exports = __webpack_public_path__ + "media/images/emoticons/bell-6cfda68b40e7649a4c12b2721fb3e3fa.gif";